module.exports = __webpack_public_path__ + "static/img/bg1.a48e640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/head/bg1.png
// module id = JfmU
// module chunks = 1